//
import qs from 'qs'
import { Model as BaseModel } from 'vue-api-query'

//
export default class Model extends BaseModel {
    //
    static appends = []
    static errors = {}
    static filters = []
    static forms = {}
    static headers = []
    static includes = []

    /**
     * define a base url for a REST API
     */
    baseURL() {
        return process.env.VUE_APP_API_ROUTE
    }

    /**
     *
     */
    clean(props) {
        //
        var clone = this.clone()

        //
        Object.keys(clone).forEach(key => {
            if (!props.some(prop => prop === key)) {
                delete clone[key]
            }
        })

        //
        return clone
    }

    /**
     *
     */
    clone() {
        return Object.assign(Object.create(Object.getPrototypeOf(this)), this)
    }

    /**
     *
     */
    error(message) {
        return {
            response: {
                data: {
                    error: message,
                },
            },
        }
    }

    /**
     * { function_description }
     *
     * @param      {string}  [path='excel']  The path
     * @param      {<type>}  [params={}]     The parameters
     * @return     {<type>}  { description_of_the_return_value }
     */
    excel(path = 'excel', params = {}) {
        return this.request({
            method: 'GET',
            params: params,
            paramsSerializer: function (params) {
                return qs.stringify(params, {arrayFormat: 'brackets'})
            },
            responseType: 'blob',
            url: path.length > 0 ? this.fullURL().concat('/').concat(path) : this.fullURL(),
        })
    }

    /**
     *
     */
    static async fetchDataTable(limit, page, sort, params = {}) {
        //
        try {
            //
            return await this.modeler()
                .limit(limit)
                .page(page)
                .orderBy(sort)
                .params(params)
                .get()
        } catch (error) {
            //
            //console.error( error )

            //
            return []
        }
    }

    /**
     * Fetches a blob.
     *
     * @param      {string}  [path='']  The path
     * @return     {<type>}  The blob.
     */
    fetchBlob(path = '') {
        return this.request({
            responseType: 'blob',
            method: 'GET',
            url: this.fullURL().concat(path),
        })
    }

    /**
     * 
     * @returns 
     */
    static from(data) {
        return new this(data)
    }

    /**
     * get the full url for the current model
     */
    fullURL() {
        return [this.baseURL(), this.resource(), this.id].join('/')
    }

    /**
     * @description
     * Gets the property.
     *
     * @param      {<type>}  path    The path
     * @return     {<type>}  The property.
     */
    getProperty(path, prevent) {
        return path.split('.').reduce(this.reduceHasProperty, this) || prevent
    }

    /**
     *
     */
    static modeler() {
        return this.append(this.appends).include(this.includes)
    }

    /**
     * @description
     * { function_description }
     *
     * @return     {<type>}  { description_of_the_return_value }
     */
    pdf() {
        return this.request({
            responseType: 'blob',
            method: 'GET',
            url: this.fullURL().concat('/pdf'),
        })
    }

    /**
     * @description
     * Reduces the has property.
     *
     * @param      {<type>}  parent    The parent
     * @param      {<type>}  property  The property
     * @param      {<type>}  index     The index
     * @return     {<type>}  { description_of_the_return_value }
     */
    reduceHasProperty(parent, property, index) {
        return typeof parent === "object" && parent != null ? parent[property] : undefined
    }

    /**
     * @description
     * { function_description }
     *
     * @param      {<type>}  data    The data
     * @return     {<type>}  { description_of_the_return_value }
     */
    replace(data) {
        return this.$http.request({
            method: 'patch',
            url: this._fromResource,
            data,
        })
    }

    /**
     * implement a default request method
     *
     * @param {*} config
     */
    request(config) {
        return this.$http.request(config)
    }

    /**
     * @description
     * Resets the object.
     *
     * @return     {Object}  { description_of_the_return_value }
     */
    reset() {
        return this
    }

    /**
     * @description
     * Shows the file.
     *
     * @param      {<type>}  filename    The filename
     * @param      {<type>}  fileExtend  The file extend
     * @return     {<type>}  { description_of_the_return_value }
     */
    showFile = (filename, fileExtend) => res => {

        // create link attrs
        var fileLink = document.createElement('a')
        var fileURL = URL.createObjectURL(res.data)

        // set link attrs
        fileLink.href = fileURL
        fileLink.download = filename.concat('.').concat(fileExtend)

        // open link
        fileLink.click()
    }

    /**
     * @description
     * Uploads a file.
     *
     * @param      {<type>}  path    The path
     * @param      {<type>}  data    The data
     * @return     {<type>}  { description_of_the_return_value }
     */
    uploadFile = (path, data) => {
        return this.request({
            headers: {
                'Content-Encoding': 'gzip',
                'Content-Type': 'multipart/form-data'                
            },
            method: 'POST',
            url: this.fullURL().concat(path),
            data: data,
        })
    }
}
